<template>
  <transition name="fade">
    <div v-if="isLoading" class="loading-screen">
      <div class="loader-content">
        <div class="logo-wrapper">
          <div class="pulse-ring"></div>
          <div class="loader-circle"></div>
          <img
            src="/favicon/favicon.ico"
            alt="Rilind Tasholli Portfolio Favicon"
          />
        </div>
        <div class="progress-bar-container">
          <div class="progress-bar"></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "LoadingScreen",
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #17191a;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  overflow: hidden;
}

.loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3rem;
}

.logo-wrapper {
  position: relative;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader-circle {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid rgba(10, 191, 128, 0.1);
  border-top: 3px solid rgb(10, 191, 128);
  border-radius: 50%;
  animation: spin 1s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.pulse-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 2px solid rgb(10, 191, 128);
  border-radius: 50%;
  animation: pulse 2s cubic-bezier(0.24, 0, 0.38, 1) infinite;
}

.progress-bar-container {
  width: 200px;
  height: 2px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 1px;
  overflow: hidden;
}

.progress-bar {
  width: 100%;
  height: 100%;
  background: rgb(10, 191, 128);
  transform-origin: left;
  animation: progress 2s infinite ease-in-out;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  70% {
    transform: scale(1.5);
    opacity: 0;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

@keyframes progress {
  0% {
    transform: scaleX(0);
  }
  50% {
    transform: scaleX(0.7);
  }
  100% {
    transform: scaleX(1);
  }
}

.fade-leave-active {
  transition: opacity 0.8s ease;
}

.fade-leave-to {
  opacity: 0;
}
</style>
